export const LIB_VERSION = '18.1.3'; // autogenerated
//# sourceMappingURL=version.js.map